<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


document.querySelectorAll(".acc-header").forEach(btn => {
  btn.addEventListener("click", () => {

    const item = btn.parentElement;
    const all = document.querySelectorAll(".acc-item");

    // close others
    all.forEach(i => {
      if (i !== item) i.classList.remove("active");
    });

    // toggle current
    item.classList.toggle("active");
  });
});